// extracted by mini-css-extract-plugin
module.exports = {"adverse_information_table":"zkiFCU3","total_cell":"_2z3tUDc"};